import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import GatsbyImage from 'gatsby-image';
import url from 'url';

import assets from 'marketing-website/media/assets.json';
import generalStyles from './style/general.module.css';
import radiusStyles from './style/radius.module.css';
import positionStyles from './style/position.module.css';

const Img = props => <img {...props} />;

export default function Image({
  alt,
  block,
  borderRadius,
  bottom,
  color,
  hasShadow,
  left,
  maxWidth,
  position,
  right,
  src,
  top,
  useImageTag,
}) {
  const containerStyle = {
    maxWidth,
    bottom,
    left,
    right,
    top,
  };

  const containerClassName = cx(
    generalStyles.container,
    positionStyles[position],
    radiusStyles[borderRadius],
    `bg-${color}`,
    {
      [generalStyles.block]: block,
      [generalStyles.inlineBlock]: !block,
      [generalStyles.shadow]: hasShadow,
    }
  );

  /*
   * TODO: Remove this check and find a better way of finding broken images
   */
  if (src === undefined) {
    return null;
  }

  /*
   * Inline the image if base64 is present
   */
  let Tag;
  let imageProps;
  const { pathname } = url.parse(src);
  const gatsbyImageProps = assets[pathname];

  if (src.indexOf('base64,') !== -1) {
    Tag = Img;
    imageProps = {
      alt,
      src,
      style: { maxWidth },
    };
  } else if (useImageTag) {
    let srcSet = null;
    let imageAspectRatio = 0;
    if (gatsbyImageProps && gatsbyImageProps.resolutions) {
      srcSet = gatsbyImageProps.resolutions.srcSet;
      imageAspectRatio = gatsbyImageProps.resolutions.aspectRatio;
    }
    imageProps = {
      alt,
      src,
      srcSet,
      style: { maxWidth },
    };

    const imgStyles = {
      position: 'absolute',
      top: 0,
      left: 0,
      transition: 'opacity 0.5s',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
    };

    const breakerStyle = {
      width: '100%',
      paddingBottom: 100 / imageAspectRatio + '%',
    };

    const outerWrapperStyle = {
      position: 'relative',
    };

    const wrapperStyle = {
      position: 'relative',
      overFlow: 'hidden',
    };

    return (
      <div className={containerClassName} style={containerStyle}>
        <div className="gatsby-image-outer-wrapper" style={outerWrapperStyle}>
          <div className="gatsby-image-wrapper" style={wrapperStyle}>
            <div style={breakerStyle} />
            <Img {...imageProps} style={imgStyles} />
          </div>
        </div>
      </div>
    );
  } else {
    Tag = GatsbyImage;

    imageProps = {
      alt,
      fadeIn: true,
      sizes: { ...gatsbyImageProps.resolutions },
    };
  }

  return (
    <div className={containerClassName} style={containerStyle}>
      <Tag {...imageProps} />
    </div>
  );
}

Image.propTypes = {
  alt: PropTypes.string,
  block: PropTypes.bool,
  borderRadius: PropTypes.oneOf(Object.keys(radiusStyles)),
  bottom: PropTypes.string,
  color: PropTypes.string,
  hasShadow: PropTypes.bool,
  left: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  position: PropTypes.oneOf(Object.keys(positionStyles)),
  right: PropTypes.string,
  src: PropTypes.string.isRequired,
  top: PropTypes.string,
  useImageTag: PropTypes.bool,
};

Image.defaultProps = {
  alt: '',
  block: false,
  borderRadius: 'none',
  bottom: 'auto',
  color: 'none',
  hasShadow: true,
  left: 'auto',
  maxWidth: '100%',
  position: 'initial',
  right: 'auto',
  top: 'auto',
  useImageTag: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/Image/index.js